import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export const useRedirectAfterLogin = () => {
  const navigate = useNavigate();

  const redirectAfterLogin = useCallback(async () => {
    try {
      // Obtener el progreso del usuario
      const userProgress = await api.getUserProgress();
      
      // Si el usuario tiene cursos registrados, ir al dashboard
      if (userProgress && userProgress.length > 0) {
        navigate('/dashboard');
      } else {
        // Si no tiene cursos, ir a la página de cursos
        navigate('/courses');
      }
    } catch (error) {
      console.error('Error checking user progress:', error);
      // En caso de error, ir al dashboard por defecto
      navigate('/dashboard');
    }
  }, [navigate]);

  return { redirectAfterLogin };
};
